<template>
  <v-container>
    <v-row>
      <v-col class="pl-4">
        <h1>Klientide sünnipäevad 🎉</h1>
        <table>
          <template v-for="(month, index) in months">
            <tr :key="index">
              <td v-if="getClientsWithMatchingBirthMonth(index).length">
                <details :open="isCurrentMonth(index)">
                  <summary>{{ month }}</summary>
                  <table>
                    <tr
                      v-for="(client, i) in getClientsWithMatchingBirthMonth(
                        index
                      )"
                      :key="month + i"
                    >
                      <td>{{ client.fullName }}</td>
                      <td title="Sünnipäeva kuupäev">
                        {{ getBirthDay(client.birthDate) }}
                      </td>
                    </tr>
                  </table>
                </details>
              </td>
            </tr>
          </template>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LimitedClient from '@/dataAccess/models/LimitedClient'
import { MonthMapper } from '@/utils/datetime'

export default {
  data() {
    return {
      clients: LimitedClient.getNotArchived(),
      months: MonthMapper.getMonthNames()
    }
  },
  methods: {
    getClientsWithMatchingBirthMonth(birthMonth) {
      return this.clients.filter(obj => {
        const birthDate = new Date(obj.birthDate)
        return birthDate.getMonth() === birthMonth
      })
    },
    getBirthDay(birthDateString) {
      const birthDate = new Date(birthDateString)
      return `${padDay(birthDate.getDate())}.${padDay(
        birthDate.getMonth() + 1
      )}`
    },
    isCurrentMonth(index) {
      return new Date().getMonth() === index
    }
  }
}

function padDay(value) {
  return String(value).padStart(2, '0')
}
</script>

<style scoped>
summary {
  color: var(--v-primary-base);
  font-size: larger;
}
</style>
